export default "__VITE_ASSET__B_Wv6HPE__"